import { Component, OnDestroy, OnInit } from '@angular/core';
import { UserDAO } from '../../../../../core/services/dao/userDAO';
import { ActivatedRoute, Router } from '@angular/router';
import { Captain } from 'anchor-shared/lib/model/entity/captain';
import { CaptainDAO } from '../../../../../core/services/dao/captainDAO';
import { Vessel } from 'anchor-shared/lib/model/entity/vessel';
import { VesselDAO } from '../../../../../core/services/dao/vesselDAO';
import { DialogsService } from '../../../../../core/services/dialog.service';
import { ServiceRecordDAO } from '../../../../../core/services/dao/serviceRecordDAO';
import { UploadDAO } from '../../../../../core/services/dao/uploadDAO';
import { environment } from '../../../../../environments/environment';
import { ConstantMan } from '../../../../../core/services/constantMan';
import { BoatOwner } from 'anchor-shared/lib/model/entity/boatOwner';
import { User } from 'anchor-shared/lib/model/entity/user';
import { BoatOwnerDAO } from '../../../../../core/services/dao/boatOwnerDAO';
import { MooringLocationDAO } from '../../../../../core/services/dao/mooringLocationDAO';
import { Subscription } from 'rxjs';
import { ContainsSubscriptions } from '../../../../../core/services/interfaces/contains-subscriptions';
import { unsubscribeFromAll } from '../../../../../core/pure-functions/rx-helper';

@Component({
  selector: 'app-boatyard',
  templateUrl: './boatyard.component.html',
  styleUrls: ['./boatyard.component.scss'],
})
export class BoatyardComponent
  implements OnInit, OnDestroy, ContainsSubscriptions
{
  subs: Subscription[] = [];
  resolvedData: any;
  model: Vessel[] = [];
  captain: Captain;
  boatOwner: BoatOwner;
  vessel = {} as Vessel;
  user: User;
  photos: Map<number, string> = new Map<number, string>(); // vesselId to url
  bucket: string;
  addVesselClicked = false;

  constructor(
    private userDAO: UserDAO,
    private captainDao: CaptainDAO,
    private vesselDao: VesselDAO,
    private router: Router,
    public dialog: DialogsService,
    private recordDao: ServiceRecordDAO,
    private uploadDao: UploadDAO,
    private boatOwnerDao: BoatOwnerDAO,
    private mooringLocationDao: MooringLocationDAO,
    private route: ActivatedRoute,
  ) {
    switch (environment.envName) {
      case 'local':
        this.bucket = ConstantMan.BUCKETS.LOCAL;
        break;
      case 'local-like-production':
        this.bucket = ConstantMan.BUCKETS.LOCAL;
        break;
      case 'dev':
        this.bucket = ConstantMan.BUCKETS.DEV;
        break;
      case 'stage':
        this.bucket = ConstantMan.BUCKETS.STAGE;
        break;
      case 'prod':
        this.bucket = ConstantMan.BUCKETS.PROD;
        break;
      default:
        this.bucket = ConstantMan.BUCKETS.DEV;
        break;
    }
  }

  ngOnInit() {
    const user = this.userDAO.getCurrentUser();
    this.user = user;
    this.captain = user.captain;
    this.boatOwner = user.boatOwner;
    this.resolvedData = this.route.snapshot.data.portal;
    if (this.boatOwner) {
      this.model = this.resolvedData;
      // tese
    }
  }

  ngOnDestroy(): void {
    unsubscribeFromAll(this.subs);
  }

  addVessel() {
    if (!this.addVesselClicked) {
      this.addVesselClicked = true;
      this.vesselDao.createVessel().subscribe((result) => {
        this.model.push(result);
        this.router.navigate(['manage/boatyard/vessel/' + result.id]);
      });
    }
  }

  editVessel(i) {
    console.log('edit: ', this.model[i].name);
    this.router.navigate(['manage/boatyard/vessel/' + this.model[i].id]);
  }

  submit() {
    this.boatOwnerDao.addBoatOwnerToUser().subscribe((createdOwner) => {
      this.vessel.ownerId = createdOwner.id;
      this.vessel.anchorManaged = false;
      this.vesselDao.createForSignup(this.vessel).subscribe((createdVessel) => {
        this.userDAO.loadById(this.user.id).subscribe((res) => {
          const user = res;
          this.user = user;
          this.captain = user.captain;
          this.boatOwner = user.boatOwner;
          if (this.boatOwner) {
            const boatOwnerSub = this.vesselDao
              .getOwnerVesselsLocal()
              .subscribe((vessel) => {
                this.model = vessel;
              });
            this.subs.push(boatOwnerSub);
          }
        });
      });
    });
  }

  deleteVessel(i) {
    this.dialog.DeleteDialog(this.model[i].name).subscribe(
      (deleted) => {
        if (deleted) {
          if (this.model[i].serviceRecords) {
            this.model[i].serviceRecords.forEach((record) => {
              this.recordDao.serverDelete(record).subscribe(
                () => {},
                (err) => console.error(err),
              );
            });
          }

          let photoFiles = [];
          let insuranceFiles = [];
          let id = this.model[i].id;
          this.uploadDao.getUploadedFiles().subscribe(
            (result) => {
              photoFiles = result.Contents.map((entry) => entry.Key)
                .filter((key) => {
                  let segments = key.split('/');
                  return (
                    segments[segments.length - 3] === 'vesselphotos' &&
                    segments[segments.length - 2] === id.toString()
                  );
                })
                .map((key) => {
                  let segments = key.split('/');
                  return segments[segments.length - 1];
                });

              insuranceFiles = result.Contents.map((entry) => entry.Key)
                .filter((key) => {
                  let segments = key.split('/');
                  return (
                    segments[segments.length - 3] === 'insurance' &&
                    segments[segments.length - 2] === id.toString()
                  );
                })
                .map((key) => {
                  let segments = key.split('/');
                  return segments[segments.length - 1];
                });

              photoFiles.forEach((filename) => {
                this.uploadDao
                  .delete(filename, null, 'vesselphotos/' + id)
                  .subscribe(
                    () => {},
                    (err) => console.error(err),
                  );
              });

              insuranceFiles.forEach((filename) => {
                this.uploadDao
                  .delete(filename, null, 'insurance/' + id)
                  .subscribe(
                    () => {},
                    (err) => console.error(err),
                  );
              });
            },
            (err) => console.error(err),
          );

          this.vesselDao.serverDelete(this.model[i]).subscribe(
            () => {
              this.model.splice(i, 1);
            },
            (err) => console.error(err),
          );
        }
      },
      (err) => {
        console.error(err);
      },
    );
  }
}
